// src/errorReporting.ts

import axios from "axios";
import { ErrorReportApiUrl } from "src/components/apiUrls";

type ClientErrorPayload = {
    kind: "react-error-boundary" | "window-error" | "unhandled-rejection";
    message: string;
    name?: string;
    stack?: string;
    componentStack?: string;
    source?: string;
    line?: number;
    column?: number;
    url: string;
    userAgent: string;
    timestampUtc: string;
    release?: string;
};

declare const __APP_RELEASE__: string | undefined;

export async function uploadClientError(payload: ClientErrorPayload): Promise<void> {
    // TODO: replace this with your backend endpoint.
    // Keep this function non-throwing so error reporting does not create more errors.
    try {




         axios.post(ErrorReportApiUrl, payload)
        .catch((err) => {        });





        console.error("Client error payload:", payload);

        /*
        await fetch("/api/client-errors", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload),
            keepalive: true
        });
        */
    } catch {
        // Deliberately swallow reporting errors.
    }
}

export function createBaseErrorPayload(
    kind: ClientErrorPayload["kind"],
    message: string
): Omit<ClientErrorPayload, "message"> & { message: string } {
    return {
        kind,
        message,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestampUtc: new Date().toISOString(),
        release: typeof __APP_RELEASE__ !== "undefined" ? __APP_RELEASE__ : undefined
    };
}